<template>
  <div class="progress-tip-item" @click="goLink">
    <div class="progress-tip-item-header">
      <strong>{{title}}</strong>
      <span :class="{'vehicle': type === 'vehicle'}" v-if="link && linkText">{{linkText}}</span>
    </div>
    <p>{{desc}}</p>
    <div class="progress-tip-status" v-if="carLicense && statusText">
      <strong>{{carLicense}}</strong>
      <span :class="{'success': status === 'success', 'fail': status === 'fail'}">{{statusText}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal',
    },
    title: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: true
    },
    carLicense: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    statusText: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  methods: {
    goLink() {
      if (!this.disabled) this.$emit('click', this.link)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.progress-tip-item {
  background-color: #fff;
  padding: 30px;

  .progress-tip-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    strong {
      font-size: $ucar_font_h4;
      color: $ucar_font_color;
    }

    span {
      display: flex;
      align-items: center;
      font-size: $ucar_font_normal;
      color: $ucar_main_button;

      &::after {
        display: inline-block;
        margin-left: 20px;
        content: '';
        height: 32px;
        width: 32px;
        background: url('../assets/icon-showcase.png') 0 0 / 100% 100% no-repeat;
      }

      &.vehicle::after {
        background: url('../assets/icon-bindCar.png') 0 0 / 100% 100% no-repeat;
      }
    }
  }

  p {
    margin-top: 20px;
    font-size: $ucar_font_h5;
    color: $ucar_alert_color;
  }

  .progress-tip-status {
    margin-top: 20px;
    padding: 20px;
    border: 1PX solid $ucar_main_button;
    background-color: $ucar_light_bg;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    strong {
      display: inline-block;
      box-sizing: border-box;
      width: 180px;
      height: 42px;
      line-height: 42px;
      padding-top: 2px;
      font-size: $ucar_font_h5;
      text-align: center;
      color: #fff;
      background: url('../assets/bg-carLicense.png') 0 0 / 100% 100% no-repeat;
    }

    span {
      font-size: $ucar_font_normal;
      line-height: 1;
      color: $ucar_font_color;

      &.success {
        color: $ucar_success_color;
      }

      &.fail {
        color: $ucar_label_color;
      }
    }
  }
}

.progress-tip-item + .progress-tip-item {
  border-top: 1PX solid $ucar_light_border;
}
</style>